import { Component, OnInit, SecurityContext } from '@angular/core';
import {
  ApplicationState,
  getProducts,
  getProductsTechnicalError,
  getSelectedProductDetails,
  getUserProduct,
} from '../../../../../store/reducers';
import {
  getTealiumLocation,
  MobileProduct,
  Pack,
  PlcCodes,
  Product,
} from '@dch/products-business-logic';
import { getPiiServiceId, savePii } from '../../../../../shared/pii/pii.utils';
import { Product as UsageProduct } from '@proximus/usage-business-logic';
import { OnDestroyHookDirective } from '../../../../../shared/hooks';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { InceptionService } from '@proximus/ng-common';
import * as ProductsActions from '../../../../../store/actions/products.actions';
import { getUsageProductFrom } from 'src/app/shared/usage/util';
import { HttpClient } from '@angular/common/http';
import { DomSanitizer } from '@angular/platform-browser';
import { BrandService } from '../../../../../services/brand.service';
import { GetProductDetails } from '../../../../../store/actions/product-details.actions';
import { GetProducts } from '../../../../../store/actions/products.actions';
import { TelephonyProduct } from '@dch/products-business-logic/src/product-details/product-details-aggregator.model';

@Component({
  selector: 'mprd-telephony-level-two',
  templateUrl: './telephony-level-two.component.html',
})
export class TelephonyLevelTwoComponent
  extends OnDestroyHookDirective
  implements OnInit
{
  selectedProduct: Product;
  usageProduct: UsageProduct;
  isRes: boolean;
  hasError: boolean;
  tealiumLocation: string;
  remainingDaysLabel: string;
  isScarlet: boolean;

  faqHtml?: string;

  public packs: Array<Product> = [];
  public outOfPacks: Array<Product> = [];

  constructor(
    private route: ActivatedRoute,
    private store: Store<ApplicationState>,
    private inceptionService: InceptionService,
    private router: Router,
    private http: HttpClient,
    private sanitizer: DomSanitizer,
    private brandService: BrandService,
  ) {
    super();
  }

  ngOnInit() {
    if (this.isADeeplink()) {
      this.store.dispatch(new GetProducts());

      this.addSubscription(
        this.store.select(getUserProduct).subscribe((userProduct) => {
          if (
            userProduct &&
            ((userProduct.packs && userProduct.packs.length > 0) ||
              (userProduct.outOfPacks && userProduct.outOfPacks.length > 0))
          ) {
            const telephonyProductsAvailableForDeepLink =
              this.getTelephonyProductsAvailableForDeepLink(
                userProduct.packs,
                userProduct.outOfPacks,
              );

            if (
              !telephonyProductsAvailableForDeepLink ||
              telephonyProductsAvailableForDeepLink.length !== 1
            ) {
              this.routeToOverview();
            } else {
              this.loadSelectedTelephonyProduct(
                telephonyProductsAvailableForDeepLink[0].accessNumber,
              );
            }
          }
        }),
      );
    } else {
      this.loadTelephonyProducts();
    }
  }

  usageInitializedWith(remainingDaysLabel: string) {
    if (remainingDaysLabel) {
      this.remainingDaysLabel = remainingDaysLabel;
    }
  }

  private getProducts(serviceId) {
    this.store.dispatch(
      this.isScarlet
        ? new GetProductDetails({
            productType: 'telephony',
            serviceId,
          })
        : new ProductsActions.GetProducts(),
    );
  }

  private findTelephonyProduct(
    telephonyProducts: Product[],
    serviceID: string,
  ) {
    return telephonyProducts.find(
      (product) =>
        serviceID === product.accessNumber && PlcCodes.FT === product.plc,
    );
  }

  private scrollToTop(): void {
    setTimeout(() => {
      this.inceptionService.scrollToElement('#telephonyLevelTwo');
    });
  }

  private fetchProductDetails(data, serviceID) {
    if (data && this.isScarlet && data.telephonyProductDetails) {
      this.selectedProduct = data.telephonyProductDetails;
      this.setUsageAndLocation(this.selectedProduct);
    } else if (data && data.length > 0) {
      this.selectedProduct = this.findTelephonyProduct(data, serviceID);
      this.setUsageAndLocation(this.selectedProduct);
    }
  }

  private setUsageAndLocation(selectedProduct) {
    this.usageProduct = getUsageProductFrom(selectedProduct);
    this.tealiumLocation = getTealiumLocation(selectedProduct as any);
  }

  private loadTelephonyProducts(): void {
    const serviceID = getPiiServiceId();
    this.isScarlet = this.brandService.isScarlet();
    if (serviceID) {
      this.getProducts(serviceID);
      const getProduct$ = this.isScarlet
        ? this.store.select(getSelectedProductDetails)
        : this.store.select(getProducts);
      this.addSubscription(
        getProduct$.subscribe((data) => {
          this.fetchProductDetails(data, serviceID);
        }),
      );

      this.addSubscription(
        this.store.select(getProductsTechnicalError).subscribe((value) => {
          this.hasError = value !== null;
        }),
      );

      this.scrollToTop();

      const url = 'telephony-details-faq%7EmgnlArea=body%7E.html';
      this.http.get(url, { responseType: 'text' }).subscribe((response) => {
        this.faqHtml = this.sanitizer.sanitize(SecurityContext.HTML, response);
      });
    } else {
      this.router.navigate(['/overview']);
    }
  }

  private loadSelectedTelephonyProduct(accessNumber: string): void {
    savePii(accessNumber);
    this.loadTelephonyProducts();
  }
  private isADeeplink() {
    return this.router.url.includes('/deeplink');
  }

  private routeToOverview() {
    this.router.navigate(['/overview']);
  }

  private getTelephonyProductsAvailableForDeepLink(
    packs: Pack[],
    outOfPacks: Pack[],
  ): TelephonyProduct[] {
    const telephonyProducts: TelephonyProduct[] = [];

    packs.forEach((pack) => {
      const telephonyProduct = pack?.coreProducts?.filter(
        (product) => product && product.plc === PlcCodes.FT,
      ) as TelephonyProduct[];
      telephonyProducts.push(...telephonyProduct);
    });

    outOfPacks.forEach((outOfpack) => {
      const telephonyProduct = outOfpack?.coreProducts?.filter(
        (product) => product && product.plc === PlcCodes.FT,
      ) as TelephonyProduct[];
      telephonyProducts.push(...telephonyProduct);
    });

    return telephonyProducts;
  }
}
